        import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <h2 className="section-title">About Me</h2>
        <div className="about-content">
          <div className="about-text">
            <p className="about-description">
              I am an IT student specializing in Cybersecurity and Full-Stack Development, focused on building secure and scalable applications while implementing practical security measures. I combine offensive and defensive security knowledge with hands-on development experience to create robust and reliable digital solutions.
            </p>
            <div className="experience-grid">
              <div className="experience-item">
                <h3>Security Expertise</h3>
                <ul>
                  <li>Penetration Testing</li>
                  <li>Vulnerability Assessment</li>
                  <li>Web Application Security (XSS, IDOR, SSRF, SQLi)</li>
                  <li>Security Auditing & Risk Analysis</li>
                  <li>Incident Response Fundamentals</li>
                </ul>
              </div>
              
              <div className="experience-item">
                <h3>Development Skills</h3>
                <ul>
                  <li>Full-Stack Web Development (PHP, Laravel, HTML, CSS, JavaScript)</li>
                  <li>RESTful API Design & Implementation</li>
                  <li>Database Management (MySQL)</li>
                  <li>Python Automation for Security Tools & Scripts</li>
                </ul>
              </div>
            </div>

            <div className="about-cta">
              <a href="#contact" className="cta-button">Get in Touch</a>
              <a href="#projects" className="cta-button secondary">View Projects</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About; 